<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Bloquear Atendimentos de Subgrupo</h3>
				</div>
				<div class="modal-body">
					<template v-if="dados.tipo_consumo == 1">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label for="">Atendimentos distribuidos (Por paciente)</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_paciente_original"
									>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group disable">
									<label for="">Atendimentos disponíveis (Por paciente)</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_paciente_alterada"
									>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label for="">Atendimentos bloqueados (Por paciente)</label>
									<input
										type="number"
										min="0"
										class="form-control"
										v-model.number="dados.quantidade_paciente_bloqueada"
									>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label for="">Atendimentos distribuidos</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_atendimento_original"
									>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group disable">
									<label for="">Atendimentos disponíveis</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_atendimento_alterada"
									>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label for="">Atendimentos bloqueados</label>
									<input
										type="number"
										min="0"
										class="form-control"
										v-model.number="dados.quantidade_atendimento_bloqueada"
									>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label for="">Locais distribuidos</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_local_original"
									>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group disable">
									<label for="">Locais disponíveis</label>
									<input
										type="text"
										class="form-control"
										:disabled="true"
										:value="dados.quantidade_local_alterada"
									>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label for="">Locais bloqueados</label>
									<input
										type="number"
										min="0"
										class="form-control"
										v-model.number="dados.quantidade_local_bloqueada"
									>
								</div>
							</div>
						</div>
					</template>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button
								@click="salvar()"
								class="btn btn-primary pull-right"
								type="button"
							><i class="fa fa-save"></i> Salvar</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i class="fa fa-close"></i> Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
	filters: { },
	computed: { },
	props: ["show", "id"],
	data: () => ({
        filtros: { },
        bloqueados: {
            atendimento: 0,
			paciente: 0,
            local: 0,
        },
		dados: {
            quantidade_atendimento: 0,
			quantidade_atendimento_original: 0,
			quantidade_atendimento_alterada: 0,
			quantidade_atendimento_bloqueada: "",
            quantidade_local: 0,
            quantidade_local_original: 0,
            quantidade_local_alterada: 0,
            quantidade_local_bloqueada: "",
			quantidade_paciente: 0,
			quantidade_paciente_original: 0,
			quantidade_paciente_alterada: 0,
			quantidade_paciente_bloqueada: "",
        },
	}),
	mounted() {
		document.body.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.$emit('close');
			}
		})
	},
	methods: {
		getData(id) {
			this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;
			axios.get(
				`${this.$store.state.serverURI}/api/distribuicao/agenda/getDistribuicaoContratoSubgrupoAtendimentosById/${id}`,
				config
			).then(response => {
                this.dados = response.data;
                this.bloqueados.atendimento = this.dados.quantidade_atendimento_bloqueada ? this.dados.quantidade_atendimento_bloqueada : 0;
                this.dados.quantidade_atendimento_alterada = this.dados.quantidade_atendimento;
                this.bloqueados.local = this.dados.quantidade_local_bloqueada ? this.dados.quantidade_local_bloqueada : 0;
                this.dados.quantidade_local_alterada = this.dados.quantidade_local;
				this.bloqueados.paciente = this.dados.quantidade_paciente_bloqueada ? this.dados.quantidade_paciente_bloqueada : 0;
                this.dados.quantidade_paciente_alterada = this.dados.quantidade_paciente;
				this.$store.commit("TOGGLE_LOADING");
			}).catch(error => {
				this.$store.commit("throwException", error);
            });

		},
        salvar() {
            console.log("teste");
            this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			axios.post(
				`${this.$store.state.serverURI}/api/distribuicao/agenda/bloquearAtendimentoSubgrupo/${this.dados.id}`,
				this.dados,
				config
			).then(response => {
                this.$emit('atualizar');
                this.$emit('close');
				this.$store.commit("TOGGLE_LOADING");
			}).catch(error => {
				this.$store.commit("throwException", error);
            });
        }
	},
	watch: {
		'show': function (value, oldValue) {
			if (value) {
				this.getData(this.id);
			}
		},
        'dados.quantidade_atendimento_bloqueada': function (value, oldValue) {
			if (!value) {
				value = 0
			}
			let qtd = parseInt(this.dados.quantidade_atendimento) + parseInt(this.bloqueados.atendimento)
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_atendimento_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_atendimento_bloqueada = qtd;
			}
		},
        'dados.quantidade_local_bloqueada': function (value, oldValue) {
            if (!value) {
                value = 0
			}
			let qtd = parseInt(this.dados.quantidade_local) + parseInt(this.bloqueados.local)
            if (qtd >= parseInt(value)) {
                this.dados.quantidade_local_alterada = qtd - parseInt(value);
            } else {
                this.dados.quantidade_local_bloqueada = qtd;
            }
		},
		'dados.quantidade_paciente_bloqueada': function (value, oldValue) {
			if (!value) {
				value = 0
			}
			let qtd = parseInt(this.dados.quantidade_paciente) + parseInt(this.bloqueados.paciente)
			if (qtd >= parseInt(value)) {
				this.dados.quantidade_paciente_alterada = qtd - parseInt(value);
			} else {
				this.dados.quantidade_paciente_bloqueada = qtd;
			}
		},
    },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// bloquearSubgruposModal.vue?6d322c0a